import React from "react";

import CafePin from "../../../images/RED-FOX-PIN.png";
import { motion } from "framer-motion";

import MapImage from "./MapImage";

import "./map.css";

export default function Map({ data, selectedId }) {
  const upRightCorner = [32.6145083, 51.6783142];
  const upLeftCorner = [32.6145083, 51.6741943];
  const lowerLeftCorner = [32.6116164, 51.6741943];

  const wLength = upRightCorner[1] - upLeftCorner[1];
  const hLength = upLeftCorner[0] - lowerLeftCorner[0];

  function offsetClac(lat, long) {
    const wOffset = long - upLeftCorner[1];
    const hOffset = upLeftCorner[0] - lat;

    return [(wOffset / wLength) * 100, (hOffset / hLength) * 100];
  }

  const redFox = [data.RedFoxLocation.Latitude, data.RedFoxLocation.Longitude];
  const [left, top] = offsetClac(redFox[0], redFox[1]);

  const nodes = data.DeliverLocations.filter((val) => {
    return !selectedId || val.DeliverLocationId === selectedId;
  }).map((val) => {
    const [l, t] = offsetClac(val.Latitude, val.Longitude);
    return (
      <motion.span
        className="node"
        initial={{
          opacity: 0,
        }}
        animate={{
          opacity: 1,
        }}
        transition={{
          duration: 0.3,
          delay: 2 + Math.random() * 1.5,
        }}
        key={val.DeliverLocationId}
        style={{
          left: `${l}%`,
          top: `${t}%`,
        }}
      ></motion.span>
    );
  });

  const centerMap = {
    translate: `-${left}%`,
    transformOrigin: `${left}% ${top}%`,
  };

  return (
    <>
      <div className="map">
        <div className="map-image" style={centerMap}>
          <MapImage />

          <motion.span
            initial={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{
              duration: 0.3,
              delay: 2,
            }}
          >
            <img
              src={CafePin}
              alt=""
              className="redfox-pin"
              style={{
                left: `${left}%`,
                top: `${top}%`,
              }}
            />
          </motion.span>
          {nodes}
        </div>
      </div>
    </>
  );
}
